import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Gear = ({ style })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: style.fontSize,
            height: style.fontSize
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: style.fontSize,
            height: style.fontSize,
            viewBox: "0 0 16 16",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "menu-4"
                }),
                /*#__PURE__*/ _jsxs("g", {
                    fill: "currentColor",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            fill: "currentColor",
                            d: "M8,14H1c-0.552,0-1-0.448-1-1v0c0-0.552,0.448-1,1-1h7c0.552,0,1,0.448,1,1v0C9,13.552,8.552,14,8,14z"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("path", {
                            fill: "currentColor",
                            d: "M15,4H1C0.448,4,0,3.552,0,3v0c0-0.552,0.448-1,1-1h14c0.552,0,1,0.448,1,1v0C16,3.552,15.552,4,15,4z"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("path", {
                            "data-color": "color-2",
                            d: "M15,9H1C0.448,9,0,8.552,0,8v0c0-0.552,0.448-1,1-1h14c0.552,0,1,0.448,1,1v0 C16,8.552,15.552,9,15,9z"
                        })
                    ]
                })
            ]
        })
    });
};
export default Gear;
